import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { clientsAPI, intermediairesAPI } from '../../services/api';
import { useLanguage } from '../../contexts/LanguageContext';
import { useAuth } from '../../contexts/AuthContext';
import { theme } from '../../theme';

const PAYS_EU = ['France','Belgique','Allemagne','Autriche','Espagne','Italie','Pays-Bas',
  'Irlande','Suède','Danemark','Finlande','Norvège','Suisse','Portugal','Luxembourg'];

const EMPTY_CTT = { titre:'M.', nom:'', prenom:'', fonction:'', email:'', telephone:'', destinataire_comms:true };

const lbl = { fontSize:12, color:'#64748B', display:'block', marginBottom:6, fontWeight:500 };
const inp = { border:'1px solid #D9D9D5', borderRadius:8, padding:'10px 12px', width:'100%', fontSize:14, boxSizing:'border-box', fontFamily:'inherit', outline:'none', transition:'border-color .12s, box-shadow .12s' };

const ORANGE = theme.orange;
const SvgIcon = ({ size = 16, color = 'currentColor', children }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke={color} strokeWidth="1.75" strokeLinecap="round" strokeLinejoin="round" style={{ flexShrink: 0 }}>
    {children}
  </svg>
);
const TAB_ICONS = {
  0: (c) => (<SvgIcon color={c}><path d="M8 9h8M8 13h6M3 7a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v8a2 2 0 0 1 -2 2h-9l-4 4v-4h-1a2 2 0 0 1 -2 -2z"/></SvgIcon>),
  1: (c) => (<SvgIcon color={c}><path d="M3 21l18 0M5 21v-16a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v16M9 7h2M9 11h2M9 15h2"/></SvgIcon>),
  2: (c) => (<SvgIcon color={c}><path d="M9 7a4 4 0 1 0 0 0M3 21v-2a4 4 0 0 1 4 -4h4a4 4 0 0 1 4 4v2M16 3.13a4 4 0 0 1 0 7.75M21 21v-2a4 4 0 0 0 -3 -3.85"/></SvgIcon>),
  3: (c) => (<SvgIcon color={c}><path d="M3 7m0 2a2 2 0 0 1 2 -2h14a2 2 0 0 1 2 2v9a2 2 0 0 1 -2 2h-14a2 2 0 0 1 -2 -2zM8 7v-2a2 2 0 0 1 2 -2h4a2 2 0 0 1 2 2v2"/></SvgIcon>),
};

function Field({ label, value, onChange, placeholder, type='text', mt=0 }) {
  const [focus, setFocus] = useState(false);
  return (
    <div style={{ marginTop:mt }}>
      {label && <label style={lbl}>{label}</label>}
      <input type={type} value={value} onChange={e => onChange(e.target.value)}
        onFocus={()=>setFocus(true)} onBlur={()=>setFocus(false)}
        placeholder={placeholder}
        style={{ ...inp,
          borderColor: focus ? '#F18A00' : '#D9D9D5',
          boxShadow: focus ? '0 0 0 3px rgba(241,138,0,0.15)' : 'none' }} />
    </div>
  );
}


function CreerClientModal({ clientId, emailDefaut, t }) {
  const [open, setOpen] = React.useState(false);
  const [email, setEmail] = React.useState(emailDefaut || '');
  const [pwd, setPwd]     = React.useState('');
  const [saving, setSaving] = React.useState(false);
  const [created, setCreated] = React.useState(null);
  const [error, setError]  = React.useState('');

  function genPwd() {
    const ch = 'ABCDEFGHJKMNPQRSTUVWXYZabcdefghjkmnpqrstuvwxyz23456789!@#';
    return Array.from({length:10},()=>ch[Math.floor(Math.random()*ch.length)]).join('');
  }

  async function save() {
    if (!email.trim() || !pwd.trim()) return;
    setSaving(true); setError('');
    try {
      const token = localStorage.getItem('arcus_token');
      const res = await fetch(`/api/clients/${clientId}/creer-client`, {
        method:'POST', headers:{'Content-Type':'application/json', Authorization:`Bearer ${token}`},
        body: JSON.stringify({ email, password: pwd }),
      });
      const data = await res.json();
      if (data.error) { setError(data.error); return; }
      setCreated(data);
    } catch(e) { setError(e.message); }
    finally { setSaving(false); }
  }

  if (!clientId) return null;
  return (
    <>
      <button onClick={()=>{ setOpen(true); setCreated(null); setError(''); setPwd(genPwd()); }}
        style={{ fontSize:11, padding:'4px 10px', borderRadius:6,
          border:'1px solid #A78BFA', color:'#7C3AED', background:'#F5F3FF',
          cursor:'pointer', fontWeight:600, display:'flex', alignItems:'center', gap:4 }}>
        🔑 {t('nav.creer_acces_client')}
      </button>
      {open && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.45)',display:'flex',
          alignItems:'center',justifyContent:'center',zIndex:1200}}>
          <div style={{background:'#fff',borderRadius:12,padding:24,width:440,maxWidth:'92vw'}}>
            <div style={{fontSize:15,fontWeight:800,marginBottom:4}}>🔑 {t('nav.creer_acces_client')}</div>
            <div style={{fontSize:12,color:'#64748B',marginBottom:16}}>{t('nav.creer_acces_client_subtitle')}</div>
            {created ? (
              <div style={{background:'#F5F3FF',border:'1px solid #A78BFA',borderRadius:8,padding:16,marginBottom:16}}>
                <div style={{fontSize:13,fontWeight:700,color:'#7C3AED',marginBottom:8}}>✓ {t('nav.acces_client_cree')}</div>
                <div style={{fontSize:13,marginBottom:4}}>📧 <b>Email :</b> {created.email}</div>
                <div style={{fontSize:13}}>🔐 <b>Mot de passe :</b>
                  <code style={{background:'#EDE9FE',padding:'2px 8px',borderRadius:4,marginLeft:6,fontWeight:700}}>{pwd}</code>
                </div>
              </div>
            ) : (
              <>
                {error && <div style={{background:'#FEE2E2',borderRadius:7,padding:'8px 12px',
                  fontSize:13,color:'#991B1B',marginBottom:12}}>⚠ {error}</div>}
                <div style={{marginBottom:12}}>
                  <label style={{fontSize:12,color:'#64748B',display:'block',marginBottom:4,fontWeight:700}}>Email</label>
                  <input type="email" value={email} onChange={e=>setEmail(e.target.value)}
                    style={{width:'100%',border:'1px solid #E2E8F0',borderRadius:6,padding:'7px 10px',fontSize:13,boxSizing:'border-box'}}/>
                </div>
                <div style={{marginBottom:16}}>
                  <label style={{fontSize:12,color:'#64748B',display:'block',marginBottom:4,fontWeight:700}}>Mot de passe temporaire</label>
                  <div style={{display:'flex',gap:8}}>
                    <input value={pwd} onChange={e=>setPwd(e.target.value)}
                      style={{flex:1,border:'1px solid #E2E8F0',borderRadius:6,padding:'7px 10px',fontSize:13,fontFamily:'monospace',fontWeight:700}}/>
                    <button onClick={()=>setPwd(genPwd())}
                      style={{padding:'7px 10px',borderRadius:6,border:'1px solid #E2E8F0',background:'#F8FAFC',cursor:'pointer',fontSize:12}}>🔄</button>
                  </div>
                </div>
              </>
            )}
            <div style={{display:'flex',gap:8,justifyContent:'flex-end'}}>
              <button onClick={()=>setOpen(false)}
                style={{fontSize:14,padding:'7px 16px',borderRadius:6,border:'1px solid #CBD5E1',cursor:'pointer',background:'#fff'}}>
                {created ? 'Fermer' : 'Annuler'}
              </button>
              {!created && (
                <button onClick={save} disabled={!email.trim()||!pwd.trim()||saving}
                  style={{fontSize:14,padding:'7px 16px',borderRadius:6,background:'#7C3AED',
                    color:'#fff',border:'none',cursor:'pointer',fontWeight:700,
                    opacity:(!email.trim()||saving)?0.5:1}}>
                  {saving ? '…' : 'Générer un accès'}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default function FicheClient() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { t } = useLanguage();
  const { isCourtier, isClient, isArcus, user, isReadOnly } = useAuth();
  const isEdit = Boolean(id);
  const readOnly = isCourtier || isClient; // Courtier + Client : consultation uniquement

  const ACTIVITES = [
    t('polices.act1'), t('polices.act2'), t('polices.act3'),
    t('polices.act4'), t('polices.act5'),
  ];

  const [slide, setSlide]   = useState(0);
  // Client: forcer démarrage sur premier slide visible
  useEffect(() => { if (isClient) setSlide(0); }, [isClient]);
  const [saving, setSaving] = useState(false);
  const [error, setError]   = useState('');
  const [intermediaires, setIntermediaires] = useState([]);

  // Slide 1 — La relation
  const [statut, setStatut]               = useState('prospect');
  const [marchePays, setMarchePays]       = useState('France');
  const [typeRelation, setTypeRelation]   = useState('direct');
  const [intermediaireId, setIntermediaireId] = useState('');

  // Slide 2 — L'entreprise
  const [nom, setNom]                         = useState('');
  const [statutJuridique, setStatutJuridique] = useState('');
  const [nImmatriculation, setNImmatriculation] = useState('');

  // Slide 2 — Adresse siège
  const [adresse1, setAdresse1]     = useState('');
  const [adresse2, setAdresse2]     = useState('');
  const [codePostal, setCodePostal] = useState('');
  const [ville, setVille]           = useState('');
  const [adressePays, setAdressePays] = useState('France');

  // Slide 3 — Les contacts
  const [contacts, setContacts] = useState([{ ...EMPTY_CTT }]);

  // Slide 4 — Les activités
  const [activitePrincipale, setActivitePrincipale] = useState('');
  const [activitesSecondaires, setActivitesSecondaires] = useState([]);

  // Client: masquer "La relation" et "Les activités"
  const ALL_SLIDES = [
    { label: t('clients.tab_relation'),   idx: 0 },
    { label: t('clients.tab_company'),    idx: 1 },
    { label: t('clients.tab_contacts'),   idx: 2 },
    { label: t('clients.tab_activities'), idx: 3 },
  ];
  const SLIDES_VISIBLE = isClient
    ? ALL_SLIDES.filter(s => s.idx === 1 || s.idx === 2)
    : ALL_SLIDES;
  const SLIDES = SLIDES_VISIBLE.map(s => s.label);

  useEffect(() => {
    intermediairesAPI.list({ statut:'actif' }).then(data => {
      setIntermediaires(data);
      // Courtier : forcer son propre intermédiaire (depuis JWT en priorité)
      if (isCourtier) {
        if (user?.intermediaire_id) {
          setIntermediaireId(user.intermediaire_id);
        } else {
          // Fallback : lookup par email du courtier
          fetch('/api/auth/my-intermediaire', {
            headers: { Authorization: `Bearer ${localStorage.getItem('arcus_token')}` }
          }).then(r => r.json()).then(d => {
            if (d.id) setIntermediaireId(d.id);
          }).catch(() => {});
        }
      }
    }).catch(()=>{});
    if (!id) return;
    clientsAPI.get(id).then(d => {
      setStatut(d.statut || 'prospect');
      setMarchePays(d.marche_pays || 'France');
      setTypeRelation(d.type_relation || 'direct');
      setIntermediaireId(d.intermediaire_id || '');
      setNom(d.nom || '');
      setStatutJuridique(d.statut_juridique || '');
      setNImmatriculation(d.n_immatriculation || '');
      const siege = d.adresses?.find(a => a.est_siege) || d.adresses?.[0];
      if (siege) {
        setAdresse1(siege.adresse_1 || '');
        setAdresse2(siege.adresse_2 || '');
        setCodePostal(siege.code_postal || '');
        setVille(siege.ville || '');
        setAdressePays(siege.pays || 'France');
      }
      if (d.contacts?.length) setContacts(d.contacts);
      // Load activities
      if (d.activites?.length) {
        const princ = d.activites.find(a => a.est_principale);
        const sec   = d.activites.filter(a => !a.est_principale).map(a => a.activite);
        if (princ) setActivitePrincipale(princ.activite);
        setActivitesSecondaires(sec);
      }
    }).catch(e => setError(e.message));
  }, [id]);

  async function save() {
    if (!nom.trim()) { setError(t('clients.company_name') + ' — ' + t('common.required')); return; }
    setSaving(true); setError('');
    try {
      const activites = [];
      if (activitePrincipale) activites.push({ activite:activitePrincipale, est_principale:true });
      activitesSecondaires.forEach(a => activites.push({ activite:a, est_principale:false }));

      const payload = {
        statut: isCourtier ? 'prospect' : statut,
        marche_pays:marchePays,
        type_relation: isCourtier ? 'intermediaire' : typeRelation,
        intermediaire_id: typeRelation === 'intermediaire' ? intermediaireId : null,
        nom, statut_juridique:statutJuridique, n_immatriculation:nImmatriculation,
        adresses: [{ adresse_1:adresse1, adresse_2:adresse2, code_postal:codePostal,
          ville, pays:adressePays, est_siege:true, label:'Siège social' }],
        contacts,
        activites,
      };
      if (isEdit) await clientsAPI.update(id, payload);
      else        await clientsAPI.create(payload);
      navigate('/clients');
    } catch(e) { setError(e.message); }
    finally { setSaving(false); }
  }

  // ── Contact helpers ───────────────────────────────────────────
  function updateCtt(i, field, val) {
    setContacts(p => p.map((c,ix) => ix===i ? {...c,[field]:val} : c));
  }
  function addCtt() {
    setContacts(p => [...p, {...EMPTY_CTT, destinataire_comms:false}]);
  }
  function removeCtt(i) {
    if (i===0) return;
    setContacts(p => p.filter((_,ix) => ix!==i));
  }

  // ── Activity helpers ──────────────────────────────────────────
  function toggleSecondary(activite) {
    setActivitesSecondaires(prev =>
      prev.includes(activite)
        ? prev.filter(a => a !== activite)
        : [...prev, activite]
    );
  }

  // ── Slide 1 — La relation ─────────────────────────────────────
  function renderS1() {
    return (
      <div>
        {/* Statut */}
        <div style={{background:'#F8FAFC',borderRadius:8,padding:'12px 14px',marginBottom:16,display:'flex',alignItems:'center',justifyContent:'space-between'}}>
          <div>
            <div style={{fontSize:14,fontWeight:600}}>{t('clients.client_status')}</div>
            <div style={{fontSize:12,color:isCourtier?'#2563EB':'#64748B',marginTop:2}}>
              {isCourtier ? t('clients.broker_status_locked') : t('clients.client_status_desc')}
            </div>
          </div>
          {isCourtier ? (
            <span style={{fontSize:12,padding:'5px 14px',borderRadius:99,fontWeight:700,
              background:'#FEF3C7',color:'#92400E',border:'1px solid #FDE68A'}}>
              🔒 {t('status.prospect')}
            </span>
          ) : (
            <div style={{display:'flex',gap:8}}>
              {[{v:'prospect',l:t('status.prospect')},{v:'actif',l:t('status.client_actif')}].map(o=>(
                <button key={o.v} onClick={()=>setStatut(o.v)}
                  style={{padding:'9px 18px',borderRadius:8,fontSize:14,cursor:'pointer',fontWeight:statut===o.v?500:400,
                    background:statut===o.v?'#161616':'#fff',color:statut===o.v?'#fff':'#64748B',
                    border:statut===o.v?'none':'1px solid #D9D9D5',transition:'all .12s'}}>
                  {o.l}
                </button>
              ))}
            </div>
          )}
        </div>

        {/* Marché + Type relation */}
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:14}}>
          <div>
            <label style={lbl}>{t('clients.market')}</label>
            <select value={marchePays} onChange={e=>setMarchePays(e.target.value)} style={inp}>
              <option value="">{t('clients.market_placeholder')}</option>
              {PAYS_EU.map(p=><option key={p}>{p}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>{t('clients.relation_type')}</label>
            {isCourtier ? (
              <div style={{marginTop:6,padding:'7px 12px',borderRadius:99,fontSize:14,
                background:'#F1F5F9',color:'#475569',border:'1px solid #CBD5E1',display:'inline-flex',alignItems:'center',gap:6}}>
                🔒 {t('clients.brokered')}
              </div>
            ) : (
              <div style={{display:'flex',gap:8,marginTop:6}}>
                {[{v:'direct',l:t('clients.direct')},{v:'intermediaire',l:t('clients.brokered')}].map(o=>(
                  <button key={o.v} onClick={()=>setTypeRelation(o.v)}
                    style={{flex:1,padding:'10px',borderRadius:8,fontSize:14,cursor:'pointer',fontWeight:typeRelation===o.v?500:400,
                      background:typeRelation===o.v?'#161616':'#fff',color:typeRelation===o.v?'#fff':'#64748B',
                      border:typeRelation===o.v?'none':'1px solid #D9D9D5',transition:'all .12s'}}>
                    {o.l}
                  </button>
                ))}
              </div>
            )}
          </div>
        </div>

        {/* Courtier */}
        {typeRelation==='intermediaire'&&(
          <div style={{marginBottom:14}}>
            <label style={lbl}>{t('clients.broker_label')}</label>
            {isCourtier ? (
              <div>
                <div style={{background:'#F1F5F9',borderRadius:7,padding:'9px 12px',
                  fontSize:13,color:'#1A1A1A',display:'flex',alignItems:'center',gap:8,
                  border:'1px solid #E2E8F0'}}>
                  🔒 {intermediaires.find(i=>i.id===intermediaireId)?.nom || '—'}
                </div>
                {!intermediaireId && (
                  <div style={{background:'#FEF3C7',border:'1px solid #FDE68A',borderRadius:6,
                    padding:'7px 10px',marginTop:6,fontSize:12,color:'#92400E'}}>
                    ⚠ Votre compte courtier n'est pas encore lié à un intermédiaire.
                    Contactez un souscripteur Arcus.
                  </div>
                )}
              </div>
            ) : (
              <select value={intermediaireId} onChange={e=>setIntermediaireId(e.target.value)} style={inp}>
                <option value="">{t('clients.broker_placeholder')}</option>
                {intermediaires.filter(i=>i.type==='courtier').map(i=>(
                  <option key={i.id} value={i.id}>{i.nom}{i.taux_commission?` — ${i.taux_commission}%`:''}</option>
                ))}
              </select>
            )}
            <div style={{fontSize:12,color:'#64748B',marginTop:4}}>{t('clients.broker_auto_commission')}</div>
          </div>
        )}
      </div>
    );
  }

  // ── Slide 2 — L'entreprise ────────────────────────────────────
  function renderS2() {
    return (
      <div>
        <div style={{marginBottom:14}}>
          <label style={lbl}>{t('clients.company_name')}</label>
          <input value={nom} onChange={e=>setNom(e.target.value)}
            placeholder={t('clients.company_placeholder')} style={inp}/>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:16}}>
          <div>
            <label style={lbl}>{t('clients.legal_status')}</label>
            <select value={statutJuridique} onChange={e=>setStatutJuridique(e.target.value)} style={inp}>
              <option value="">—</option>
              {['SARL','SAS','EURL','SA','SNC','Auto-entrepreneur','Autre'].map(s=><option key={s}>{s}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>{t('clients.registration')}</label>
            <input value={nImmatriculation} onChange={e=>setNImmatriculation(e.target.value)}
              placeholder={t('clients.registration_placeholder')} style={inp}/>
          </div>
        </div>

        {/* Adresse du siège */}
        <div style={{fontSize:11,fontWeight:700,color:'#64748B',textTransform:'uppercase',
          letterSpacing:'.06em',paddingBottom:6,borderBottom:'1px solid #F1F5F9',marginBottom:12}}>
          {t('clients.address_siege')}
        </div>
        <div style={{marginBottom:10}}>
          <label style={lbl}>{t('intermediaires.address_line1')}</label>
          <input value={adresse1} onChange={e=>setAdresse1(e.target.value)}
            placeholder={t('intermediaires.address1_placeholder')} style={inp}/>
        </div>
        <div style={{marginBottom:10}}>
          <label style={lbl}>{t('intermediaires.address_line2')}</label>
          <input value={adresse2} onChange={e=>setAdresse2(e.target.value)}
            placeholder={t('intermediaires.address2_placeholder')} style={inp}/>
        </div>
        <div style={{display:'grid',gridTemplateColumns:'120px 1fr 180px',gap:10}}>
          <div>
            <label style={lbl}>{t('intermediaires.postal_code')}</label>
            <input value={codePostal} onChange={e=>setCodePostal(e.target.value)}
              placeholder={t('intermediaires.postal_placeholder')} style={inp}/>
          </div>
          <div>
            <label style={lbl}>{t('intermediaires.city')}</label>
            <input value={ville} onChange={e=>setVille(e.target.value)} placeholder="Paris" style={inp}/>
          </div>
          <div>
            <label style={lbl}>{t('common.country')}</label>
            <select value={adressePays} onChange={e=>setAdressePays(e.target.value)} style={inp}>
              {['France','Belgique','Allemagne','Autriche','Espagne','Italie','Pays-Bas',
                'Irlande','Suède','Danemark','Finlande','Norvège','Suisse','Portugal','Luxembourg'
              ].map(p=><option key={p}>{p}</option>)}
            </select>
          </div>
        </div>
      </div>
    );
  }

  // ── Slide 3 — Les contacts ────────────────────────────────────
  function renderS3() {
    return (
      <div>
        {contacts.map((c,i)=>(
          <div key={i} style={{border:`1px solid ${i===0?'#BFDBFE':'#E2E8F0'}`,borderRadius:7,padding:12,marginBottom:12,background:i===0?'#F0F9FF':'#fff'}}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:10}}>
              <span style={{fontSize:12,fontWeight:700,color:i===0?'#0369A1':'#64748B'}}>
                {i===0 ? t('clients.main_contact') : `${t('clients.contact_number')} ${i+1}`}
              </span>
              {i>0&&(
                <button onClick={()=>removeCtt(i)}
                  style={{fontSize:12,color:'#DC2626',background:'none',border:'none',cursor:'pointer',fontWeight:600}}>
                  {t('common.delete')}
                </button>
              )}
            </div>

            {/* Titre + Fonction */}
            <div style={{display:'flex',gap:8,marginBottom:10,alignItems:'flex-end'}}>
              <div>
                <label style={lbl}>{t('clients.title_contact')}</label>
                <div style={{display:'flex',gap:5}}>
                  {['M.','Mme'].map(ti=>(
                    <button key={ti} onClick={()=>updateCtt(i,'titre',ti)}
                      style={{padding:'5px 12px',borderRadius:99,fontSize:13,cursor:'pointer',
                        background:c.titre===ti?'#1A1A1A':'#fff',color:c.titre===ti?'#fff':'#64748B',
                        border:`1px solid ${c.titre===ti?'#1A1A1A':'#CBD5E1'}`,fontWeight:c.titre===ti?700:400}}>
                      {ti}
                    </button>
                  ))}
                </div>
              </div>
              <div style={{flex:1}}>
                <Field label={t('clients.role')} value={c.fonction} onChange={v=>updateCtt(i,'fonction',v)} placeholder="Ex. Directeur général" />
              </div>
            </div>

            {/* Nom + Prénom */}
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:10}}>
              <Field label={t('clients.last_name')}  value={c.nom}    onChange={v=>updateCtt(i,'nom',v)}    placeholder="Dupont" />
              <Field label={t('clients.first_name')} value={c.prenom} onChange={v=>updateCtt(i,'prenom',v)} placeholder="Jean" />
            </div>

            {/* Email + Tel */}
            <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:10,marginBottom:10}}>
              <Field label={t('clients.email')} value={c.email}     onChange={v=>updateCtt(i,'email',v)}     placeholder="jean@agence.fr" type="email" />
              <Field label={t('clients.phone')} value={c.telephone} onChange={v=>updateCtt(i,'telephone',v)} placeholder="+33 6 12 34 56 78" type="tel" />
            </div>

            {/* Destinataire comms */}
            <label style={{display:'flex',alignItems:'center',gap:8,fontSize:14,cursor:'pointer'}}>
              <input type="checkbox" checked={c.destinataire_comms}
                onChange={e=>updateCtt(i,'destinataire_comms',e.target.checked)}/>
              {t('clients.comm_recipient')}
            </label>
          </div>
        ))}

        <button onClick={addCtt}
          style={{fontSize:14,color:'#2563EB',background:'none',border:'1px dashed #93C5FD',
            borderRadius:7,padding:'9px',cursor:'pointer',width:'100%',fontWeight:600}}>
          {t('clients.add_contact')}
        </button>
      </div>
    );
  }

  // ── Slide 4 — Les activités ───────────────────────────────────
  function renderS4() {
    const secondaryOptions = ACTIVITES.filter(a => a !== activitePrincipale);

    return (
      <div>
        {/* Activité principale */}
        <div style={{marginBottom:20}}>
          <div style={{fontSize:14,fontWeight:700,marginBottom:4}}>{t('clients.principal_activity')}</div>
          <div style={{fontSize:12,color:'#64748B',marginBottom:12}}>{t('clients.principal_activity_desc')}</div>
          <div style={{display:'flex',flexDirection:'column',gap:8}}>
            {ACTIVITES.map((a,i)=>{
              const selected = activitePrincipale === a;
              return (
                <button key={i} onClick={()=>{
                    // If deselecting principal, remove from secondaries too
                    if (selected) { setActivitePrincipale(''); }
                    else {
                      // If was in secondaries, remove it
                      setActivitesSecondaires(prev => prev.filter(s => s !== a));
                      setActivitePrincipale(a);
                    }
                  }}
                  style={{display:'flex',alignItems:'center',gap:12,padding:'10px 14px',
                    border:`1.5px solid ${selected?'#F18A00':'#E2E8F0'}`,
                    borderRadius:8,cursor:'pointer',background:selected?'#FFF7F2':'#fff',
                    textAlign:'left',transition:'all .1s'}}>
                  <div style={{width:18,height:18,borderRadius:'50%',flexShrink:0,
                    border:`2px solid ${selected?'#F18A00':'#CBD5E1'}`,
                    background:selected?'#F18A00':'transparent',
                    display:'flex',alignItems:'center',justifyContent:'center'}}>
                    {selected&&<div style={{width:7,height:7,borderRadius:'50%',background:'#fff'}}/>}
                  </div>
                  <span style={{fontSize:14,color:selected?'#F18A00':'#475569',fontWeight:selected?700:400}}>{a}</span>
                </button>
              );
            })}
          </div>
        </div>

        {/* Activités secondaires */}
        <div style={{borderTop:'1px solid #F1F5F9',paddingTop:16}}>
          <div style={{fontSize:14,fontWeight:700,marginBottom:4}}>{t('clients.secondary_activities')}</div>
          <div style={{fontSize:12,color:'#64748B',marginBottom:12}}>{t('clients.secondary_activities_desc')}</div>

          {!activitePrincipale ? (
            <div style={{background:'#FEF3C7',border:'1px solid #FDE68A',borderRadius:7,padding:'10px 14px',fontSize:13,color:'#92400E'}}>
              ℹ️ {t('clients.no_activity_selected')}
            </div>
          ) : (
            <div style={{display:'flex',flexDirection:'column',gap:8}}>
              {secondaryOptions.map((a,i)=>{
                const checked = activitesSecondaires.includes(a);
                return (
                  <label key={i}
                    style={{display:'flex',alignItems:'center',gap:12,padding:'10px 14px',
                      border:`1px solid ${checked?'#93C5FD':'#E2E8F0'}`,
                      borderRadius:8,cursor:'pointer',background:checked?'#EFF6FF':'#fff'}}>
                    <input type="checkbox" checked={checked} onChange={()=>toggleSecondary(a)}
                      style={{width:16,height:16,accentColor:'#2563EB',flexShrink:0}}/>
                    <span style={{fontSize:14,color:checked?'#1D4ED8':'#475569',fontWeight:checked?600:400}}>{a}</span>
                  </label>
                );
              })}
            </div>
          )}

          {/* Résumé */}
          {(activitePrincipale||activitesSecondaires.length>0) && (
            <div style={{marginTop:16,background:'#F0FDF4',border:'1px solid #6EE7B7',borderRadius:8,padding:'10px 14px'}}>
              <div style={{fontSize:12,fontWeight:700,color:'#065F46',marginBottom:8}}>
                {activitePrincipale?1+activitesSecondaires.length:activitesSecondaires.length} {t('clients.col_activity').toLowerCase()}
              </div>
              {activitePrincipale&&(
                <div style={{display:'flex',alignItems:'center',gap:7,marginBottom:4}}>
                  <span style={{fontSize:10,padding:'2px 7px',borderRadius:99,background:'#F18A00',color:'#fff',fontWeight:700}}>{t('clients.principal_activity')}</span>
                  <span style={{fontSize:13,color:'#065F46'}}>{activitePrincipale}</span>
                </div>
              )}
              {activitesSecondaires.map((a,i)=>(
                <div key={i} style={{display:'flex',alignItems:'center',gap:7,marginBottom:2}}>
                  <span style={{fontSize:10,padding:'2px 7px',borderRadius:99,background:'#D1FAE5',color:'#065F46',fontWeight:600}}>{t('clients.secondary_activities')}</span>
                  <span style={{fontSize:13,color:'#065F46'}}>{a}</span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>
    );
  }

  // Broker: redirect to detail view (they shouldn't be here)
  if (isCourtier && id) {
    return (
      <div style={{margin:'0 auto'}}>
        <div style={{background:'#FEE2E2',border:'1px solid #FCA5A5',borderRadius:10,padding:24,textAlign:'center'}}>
          <div style={{fontSize:16,fontWeight:700,color:'#991B1B',marginBottom:8}}>🚫 {t('common.access_denied')}</div>
          <div style={{fontSize:13,color:'#7F1D1D',marginBottom:16}}>{t('clients.broker_readonly')}</div>
          <button onClick={()=>navigate(`/clients/${id}/detail`)}
            style={{background:'#1A1A1A',color:'#fff',border:'none',borderRadius:7,padding:'8px 18px',cursor:'pointer',fontSize:14,fontWeight:700}}>
            ← {t('common.close')}
          </button>
        </div>
      </div>
    );
  }

  return (
    <div style={{margin:'0 auto'}}>
      <div style={{background:'#fff',borderRadius:12,border:'0.5px solid #E8E8E5',overflow:'hidden'}}>
        {/* Header clair (style "Ligne") */}
        <div style={{padding:'16px 20px',display:'flex',alignItems:'center',gap:13,
          borderBottom:`2px solid ${theme.borderDark}`}}>
          <button onClick={()=>navigate('/clients')}
            style={{background:theme.surfaceAlt,border:`0.5px solid ${theme.border}`,width:34,height:34,borderRadius:8,cursor:'pointer',display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0}}>
            <SvgIcon size={18} color={theme.textSecondary}><path d="M15 6l-6 6l6 6"/></SvgIcon>
          </button>
          <div style={{width:42,height:42,borderRadius:'50%',background:theme.sidebarBg,display:'flex',alignItems:'center',justifyContent:'center',flexShrink:0,color:ORANGE,fontSize:15,fontWeight:500}}>
            {((isEdit?nom:'')||'?').trim().charAt(0).toUpperCase() || '+'}
          </div>
          <div style={{flex:1,minWidth:0}}>
            <div style={{fontSize:11,color:theme.textTertiary,textTransform:'uppercase',letterSpacing:'.04em'}}>{t('clients.breadcrumb')}</div>
            <div style={{fontSize:22,fontWeight:800,color:theme.text}}>{isEdit?(nom||t('clients.edit_title')):t('clients.new_title')}</div>
          </div>
          {isEdit && isArcus && (
            <CreerClientModal clientId={id} emailDefaut={''} t={t}/>
          )}
          <span style={{fontSize:12,padding:'5px 13px',borderRadius:99,fontWeight:500,display:'inline-flex',alignItems:'center',gap:6,
            background:statut==='actif'?'#E1F5EE':'#FAEEDA',color:statut==='actif'?'#0F6E56':'#854F0B'}}>
            <span style={{width:6,height:6,borderRadius:'50%',background:statut==='actif'?'#1D9E75':'#EF9F27'}}/>
            {statut==='actif'?t('status.client_actif'):t('status.prospect')}
          </span>
        </div>

        {/* Onglets avec icônes */}
        <div style={{display:'flex',borderBottom:'0.5px solid #F1F1EE',padding:'0 14px',gap:2}}>
          {SLIDES_VISIBLE.map((s,i)=>{
            const active = slide===i;
            const IconFn = TAB_ICONS[s.idx] || TAB_ICONS[0];
            return (
              <button key={i} onClick={()=>setSlide(i)}
                style={{padding:'11px 14px',fontSize:13,cursor:'pointer',background:'none',border:'none',
                  color:active?ORANGE:'#64748B',fontWeight:active?500:400,
                  borderBottom:active?`2px solid ${ORANGE}`:'2px solid transparent',whiteSpace:'nowrap',
                  display:'flex',alignItems:'center',gap:7}}>
                {IconFn(active?ORANGE:'#64748B')}
                {s.label}
              </button>
            );
          })}
        </div>

        {/* Contenu */}
        <div style={{padding:20,minHeight:420}}>
          {error&&<div style={{background:'#FEE2E2',color:'#991B1B',borderRadius:6,padding:'8px 12px',marginBottom:14,fontSize:14}}>{error}</div>}
          {SLIDES_VISIBLE[slide]?.idx === 0 && renderS1()}
          {SLIDES_VISIBLE[slide]?.idx === 1 && renderS2()}
          {SLIDES_VISIBLE[slide]?.idx === 2 && renderS3()}
          {SLIDES_VISIBLE[slide]?.idx === 3 && renderS4()}
        </div>

        {/* Footer */}
        <div style={{padding:'11px 18px',borderTop:'1px solid #F1F5F9',background:'#F8FAFC',display:'flex',alignItems:'center',justifyContent:'space-between'}}>
          <button onClick={()=>navigate('/clients')} style={{fontSize:14,color:'#64748B',background:'none',border:'none',cursor:'pointer'}}>
            {t('common.cancel')}
          </button>
          <span style={{fontSize:12,color:'#94A3B8'}}>{t('common.slide')} {slide+1} / {SLIDES.length}</span>
          <div style={{display:'flex',gap:8}}>
            {slide>0&&(
              <button onClick={()=>setSlide(s=>s-1)}
                style={{fontSize:14,padding:'7px 16px',borderRadius:6,border:'1px solid #CBD5E1',cursor:'pointer',background:'#fff'}}>
                {t('common.previous')}
              </button>
            )}
            {slide<SLIDES.length-1
              ? <button onClick={()=>setSlide(s=>s+1)}
                  style={{fontSize:14,padding:'7px 16px',borderRadius:6,border:'1px solid #CBD5E1',cursor:'pointer',background:'#fff'}}>
                  {t('common.next')}
                </button>
              : (!isReadOnly && !readOnly && <button onClick={save} disabled={saving}
                  style={{fontSize:14,padding:'7px 16px',borderRadius:6,background:'#1A1A1A',color:'#fff',border:'none',cursor:'pointer',fontWeight:700}}>
                  {saving?t('common.saving'):'✓ '+t('common.save')}
                </button>)
            }
          </div>
        </div>
      </div>
    </div>
  );
}
